<script setup lang="ts">
import { computed, ref } from 'vue'
import type { ModelRef } from 'vue'

import type { ICPTooltipPropTypes } from '~/portal/components/base'

const props = withDefaults(
	defineProps<ICPTooltipPropTypes>(),
	{
		attach: false,
		modelValue: false,
		openOnClick: false,
		openOnHover: true,
		closeOnContentClick: true,
		offset: 12,
		activator: 'parent'
	}
)

const model: ModelRef<ICPTooltipPropTypes['modelValue']> = defineModel()

const computedOpenOnHover = computed<boolean>(() => {
	return props.openOnHover && !props.openOnClick
})

// @ts-expect-error vue-tsc does not detect template ref usage
const activatorRef = ref<null | HTMLDivElement>(null)
</script>

<script lang="ts">
export default { inheritAttrs: false }
</script>

<template>
  <div
    :class="[
      'cp-tooltip',
      $attrs.class
    ]"
  >
    <VTooltip
      v-model="model"
      :attach="attach"
      :offset="offset"
      :activator="activator"
      :open-on-hover="computedOpenOnHover"
      :open-on-click="!computedOpenOnHover"
      :close-on-content-click="closeOnContentClick"
      location="top"
    >
      <template v-slot:activator="{ props: activatorProps }">
        <div
          ref="activatorRef"
          v-bind="activatorProps"
        >
          <slot name="activator" />
        </div>
      </template>
      <slot>
        {{ text }}
      </slot>
    </VTooltip>
  </div>
</template>

<style lang="scss">
	.cp-tooltip {
		.v-overlay__content {
			@apply
				py-2
				px-4
				tracking-[0.25px]
				font-normal
				text-xs
				bg-cp-neutral-600
			;
		}
	}

	.v-tooltip > .v-overlay__content {
		@apply
      b-rd-2
    bg-cp-neutral-600
		;
	}
</style>
